<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JSlpA4/tc-custom/buylink_9781476704715_cover.jpg?1718169955919?1730492845487" alt="This image is the cover for the book Taming"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taming
      </h1>
      <p class="bookDescription body article font2">
        <b><i>New York Times</i> bestselling author Jude Deveraux will keep your heart racing with this medieval romance featuring a stubborn heiress in need of a husband who has her eyes set on the kingdom's most infamous warrior.</b><br/><br/>England's most valiant knights paid court to wealthy Liana Neville, but only the infamous warrior Rogan Peregrine made no secret of his powerful desires. His very caress melted Liana into liquid fire, and she vowed to capture this manificent, wild man. Boldly the delicate beauty gave him her hand—and Britain's richest dower. Yet he was bound to a bitter feud: for love betrayed, brothers killed, and ancestral land usurped. In Rogan's war-ravaged castle, Liana would lay her tender seige...to redeem his embattled spirit and win his untamed heart!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jude Deveraux
      </h2>
      
      <p class="authorDescription body article">Jude Deveraux is the author of&#160;more than forty <I>New York Times</I> bestsellers, including <I>Moonlight in the Morning</I>, <I>The Scent of Jasmine</I>, <I>Scarlet Nights</I>, <I>Days of Gold</I>,<I> Lavender Morning</I>, <I>Return to Summerhouse</I>, and <I>Secrets. </I>To date, there are more than sixty million copies of her books in print worldwide. To learn more, visit JudeDeveraux.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?483ad30b